// 1：正式生产环境 // 2：内部测试环境 //3: '预发布环境'
const PROD = 1,
  TEST = 2,
  PRE = 3;

export const currentDev = (() => {
  // let GLOBAL_ENV = 'undefined'
  // if (["admintest"].some(item => window.location.href.includes(item))) {
  //   //测试环境
  //   GLOBAL_ENV = 'test';
  // }
  // if (["adminpre"].some(item => window.location.href.includes(item))) {
  //   //预发环境
  //   GLOBAL_ENV = 'pre';
  // }
  // if (["127.0.0.1", "localadmin.wangyuedaojia.com"].some(item => window.location.href.includes(item))) {
  //   //本地调试环境
  //   GLOBAL_ENV = 'test'
  // }

  if (typeof GLOBAL_ENV === "undefined") {
    return PROD;
  }
  if ("test" === GLOBAL_ENV) {
    return TEST;
  }
  if ("pre" === GLOBAL_ENV) {
    return PRE;
  }
  return PROD;
})();

export const isTestEnv = currentDev === TEST;
